import AssetReferralContent from "./AssetReferralContent/AssetReferralContent";
import { Referral } from "types";
import AssetReferralRegister from "./AssetReferralRegister";

export default function AssetReferralRegisterContainer({
  referralId,
  referral,
  onReferralCreated,
  setActiveTab,
  setReferralData,
  onNewDataAdded,
  handleCreateTerminationRequestClick,
  handleAddAssetRecoveryDecisionClick,
  handleAddAssetDecisionClick,
  reports,
  recoveryReports,
  handleAssetCreated
}: {
  referralId: string | undefined;
  referral: Referral | null;
  setReferralData?: React.Dispatch<React.SetStateAction<Referral | null>>;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  onReferralCreated?: (newReferralId: string) => void;
  onNewDataAdded?: (data: any) => void;
  handleCreateTerminationRequestClick?: () => void;
  handleAddAssetRecoveryDecisionClick?: () => void;
  handleAddAssetDecisionClick?: () => void;
  reports:any
  recoveryReports:any
  handleAssetCreated:()=>void
  
}) {
  return (
    <div className="flex">
      <div className="w-3/5">
        <AssetReferralRegister
          referralId={referralId}
          referral={referral}
          onReferralCreated={onReferralCreated}
          setReferralData={setReferralData}
          setActiveTab={setActiveTab}
          onNewDataAdded={onNewDataAdded}
          handleCreateTerminationRequestClick={handleCreateTerminationRequestClick}
          handleAddAssetRecoveryDecisionClick={handleAddAssetRecoveryDecisionClick}
          handleAddAssetDecisionClick={handleAddAssetDecisionClick}
        />
      </div>
      {referralId && (
        <div className="mt-3 w-2/5">
          <AssetReferralContent
            referralId={referralId}
            referralData={referral}
            setReferralData={setReferralData}
            setActiveTab={setActiveTab}
            recoveryReports={recoveryReports}
            reports={reports}
            handleAssetCreated={handleAssetCreated}
          />
        </div>
      )}
    </div>
  );
}
